import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Form, Row, Col } from "react-bootstrap";
import "./SubcontractorDetails.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, ToastMessage } from '../../components'
import ItemList from '../../containers/ItemList/ItemList'
import ProviderToSubcontractorModal from "../../components/ProviderToSubcontractorModal/ProviderToSubcontractorModal"
import formatCnpj from '../../helpers/formatCnpj';

function SubContractorDetails(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
    
    const selectedSubcontractor = useSelector(state => state.subcontractor.selectedSubcontractor);
    const isLoading             = useSelector(state => state.subcontractor.isLoading);
    const fetchedSubcontractor  = useSelector(state => state.subcontractor.fetchedSubcontractorDetails);
    const getSubcontractor      = useSelector(state => state.subcontractor.getSubcontractor);

    const fetchedProvidersBySubcontractor   = useSelector(state => state.provider.fetchedProvidersBySubcontractor.buscarFornecedorPorSubcontratado);
    const isTableLoading                    = useSelector(state => state.provider.fetchedProvidersBySubcontractor.loading);
    const reloadProviderList                = useSelector(state => state.provider.fetchedProvidersBySubcontractor.reloadProviderList);
    	    
	const pageMessages = messages[lang].subcontractorDetailsPage

    const subcontractorToast = useSelector(state => state.subcontractor.subcontractorToast);

    const [showToast,      setShowToast]    = useState(false);
    const [messageError,   setMessageError] = useState('');
    const [messageType,    setMessageType]  = useState('toast-success');    	
    const [validated,      setValidated]    = useState(false);
    const [showModal,      setShowModal]    = useState(false);


    const [formFields, setFormFields] = useState({
        razaoSocial: '',
        nomeFantasia: '',
        cnpj: '',
        endereco: '',
        telefonePrincipal: '',
        outroTelefone: '',
        email: '',
        codigoABVTEX: '',
        status: 1
    });  
        
	const pageBack = () => {
		props.history.push(`/subcontractor-list`);
    };

    const [isEdit, setIsEdit] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;

        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity()) {
            if (isEdit) {
                dispatch({
                    type: 'EDIT_SUBCONTRACTOR_DETAILS',
                    payload: formFields
                })
            } else {
                dispatch({
                    type: 'CREATE_NEW_SUBCONTRACTOR',
                    payload: formFields
                })
            }
        }
    
        setValidated(true);
    };

    useEffect(() => {	
        setShowToast(subcontractorToast.showToast)
        setMessageError(subcontractorToast.message)
        setMessageType(subcontractorToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subcontractorToast]);
   
	useEffect(() => {
        if (selectedSubcontractor.id) {
            setIsEdit(true)

            dispatch({
                type: 'UNSET_SELECTED_SUBCONTRACTOR',
                payload: {
                    id: null,
                    data: selectedSubcontractor.data
                }
            })

            dispatch({
                type: 'GET_SUBCONTRACTOR_DETAILS',
                payload: {
                    subcontractorId: selectedSubcontractor.data.id
                }
            })
            handleGetProvidersList(selectedSubcontractor.data.id);            
        } else {
            setIsEdit(false)
         
            dispatch({
                type: 'UNSET_SELECTED_SUBCONTRACTOR',
                payload: {
                    id: null,
                    data: {}
                }
            })

            dispatch({
                type: 'CLEAN_PROVIDERS_BY_SUBCONTRACTOR'
            })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {	
        if (getSubcontractor) {
            setIsEdit(true)

            dispatch({
                type: 'GET_SUBCONTRACTOR_DETAILS',
                payload: {
                    subcontractorId: getSubcontractor
                }
            })
            handleGetProvidersList(getSubcontractor)
            dispatch({ type: 'SET_GET_SUBCONTRACTOR', payload: null });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getSubcontractor]);

    useEffect(() => {
        if (isEdit) {
            setFormFields({
                id: fetchedSubcontractor.id,
                razaoSocial: fetchedSubcontractor.razaoSocial,
                nomeFantasia: fetchedSubcontractor.nomeFantasia,
                cnpj: fetchedSubcontractor.cnpj,
                endereco: fetchedSubcontractor.endereco, 
                telefonePrincipal: fetchedSubcontractor.telefonePrincipal, 
                outroTelefone: fetchedSubcontractor.outroTelefone, 
                email: fetchedSubcontractor.email, 
                codigoABVTEX: fetchedSubcontractor.codigoABVTEX, 
                anotacoes: fetchedSubcontractor.anotacoes,
                status: fetchedSubcontractor.status.id
            })
        } else {
            setFormFields({                
                razaoSocial: '',
                nomeFantasia: '',
                cnpj: '',
                endereco: '',
                telefonePrincipal: '',
                outroTelefone: '',
                email: '',
                codigoABVTEX: '',
                status: 1
            })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchedSubcontractor]);

    const statusOptions = [
        { id: 1, message: 'Ativo' },
        { id: 2, message: 'Inativo' },
    ];

    useEffect(() => {
        if (!fetchedSubcontractor.id || reloadProviderList === 0) {
            return;
        }
        handleGetProvidersList(fetchedSubcontractor.id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadProviderList]);

    const handleGetProvidersList = (subcontractorId) => {
        dispatch({
            type: 'GET_PROVIDERS_BY_SUBCONTRACTOR',
            payload: {
                subcontractorId: subcontractorId
            }
        })

        dispatch({
            type: 'GET_PROVIDERS_NOT_LINKED_SUBCON',
            payload: {
                subcontractorId: subcontractorId
            }
        })
    }

    const buttonGroupRight = disabled => () => {
        return <>
        {
            <ButtonStandard
                id="norm_save_button"
                type="submit"
                text={messages[lang].save}
                textClass="text-2"
                isLoading={isLoading}
                disabled={disabled}
                className="btn btn-primary btn-save btn-light" />
        }
        </>
    };

    
    const buttonGroupLeft = disabled => () => {
        return <>
        {
            <ButtonStandard 
			    id="reconcile_reconcile_button"
			    text={pageMessages.addFornecedor}
                type="button"
			    textClass="text-2"
			    isLoading={isLoading}
                disabled={disabled}
			    className="btn btn-primary btn-save btn-light"
			    onClick={() => handleButtonAddProvider() }
		/>
        }
        </>
    };

    const handleButtonAddProvider = () => {
        if (fetchedSubcontractor.id) {
            setShowModal(true)
            return;
        }
        setShowToast(true)
        setMessageError('Para vincular um novo fornecedor, o subcontratado deve ser salvo previamente')
        setMessageType('toast-error')
    }

    const mappedProviderList = () => {
        if (fetchedProvidersBySubcontractor.length === 0) {
            return []
        }

        return fetchedProvidersBySubcontractor.map((item) => {
            return [
                    item.id,
                    { 
                        text: item.cnpj ? formatCnpj(item.cnpj) : '',
                    },
                    { 
                        text: item.nome,
                        maxLength: 4000
                    },
                    {
						text: <i className="icon-remove" />,
                        onClick: () => {
							dispatch({
                                type: 'REMOVE_PROVIDER_SUBCONTRACTOR',
                                payload: { fornecedorId: item.id, subcontratadoId: fetchedSubcontractor.id }
                            })
						},
					}
                ]
        });
    }

    const header = [
        pageMessages.codigo,
        pageMessages.cnpj,
        pageMessages.nome,
        ""
    ];
    
    const titleTable   = pageMessages.fornecedoresVinculados;

	return (
		<div className="subcontractor-details-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={'Detalhes Subcontratado'}
			/>

            <ProviderToSubcontractorModal
                show={showModal}
                onHide={() => { 
                    setShowModal(false) 
                    }} />

            <div>
                <Container className="pt-3 justify-content-start">
                    <div>
                    <Form noValidate validated={validated} className="px-3" onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} xs={4} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.razaoSocial}</Form.Label>

                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.razaoSocial}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, razaoSocial: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>

                            <Form.Group as={Col} xs={4} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.nomeFantasia}</Form.Label>
                                
                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.nomeFantasia || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, nomeFantasia: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>
                            </Form.Group>	

                            <Form.Group as={Col} xs={4} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.cnpj}</Form.Label>

                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.cnpj || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, cnpj: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>


                        </Row>

                        <Row>
                            <Form.Group as={Col} xs={12} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.endereco}</Form.Label>

                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.endereco || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, endereco: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col} xs={4} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.telefonePrincipal}</Form.Label>

                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.telefonePrincipal || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, telefonePrincipal: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>

                            <Form.Group as={Col} xs={4} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.outroTelefone}</Form.Label>
                                
                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.outroTelefone || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, outroTelefone: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>
                            </Form.Group>	

                            <Form.Group as={Col} xs={4} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.email}</Form.Label>
                                
                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.email || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, email: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.status}</Form.Label>

                                <Form.Control
                                    required
                                    as="select"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.status || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, status: event.target.value },
                                    )}
                                >
                                    {
                                        statusOptions.map(value => (
                                            <option key={value.message} value={value.id}>{value.message}</option>
                                        ))
                                    } 
                                </Form.Control>

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>

                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.codigoAbvtex}</Form.Label>

                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.codigoABVTEX || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, codigoABVTEX: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>	
                        </Row>
                        
                        <Row className="mt-1">
                            <ItemList
                                header={header}
                                titleTable={titleTable}
                                isLoading={isTableLoading}
                                isEmpty={fetchedProvidersBySubcontractor.length === 0}
                                listTable={mappedProviderList()}
                            />
                        </Row>
                        <FooterActions
                            ButtonGroupRight={buttonGroupRight(isLoading)}
                            ButtonGroupLeft={buttonGroupLeft(isLoading)}
                        />
                    </Form>
                    </div>
                </Container>
            </div>               
		</div>
	)
}
export default withRouter(SubContractorDetails);